import { calendarService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";
import { useCalendarStore } from "../../stores/calendarsStore/calendarsStore";

const getCalendarSetsUUID = createUUID();

export const useMyCalendarSets = () => {
  const stateManager = useComponentState();

  const myCalendarSets = useCalendarStore((state) => state.myCalendarSets);

  const setMyCalendarSets = useCalendarStore(
    (state) => state.setMyCalendarSets
  );

  const getMyCalendarSets = () => {
    stateManager.abort(getCalendarSetsUUID);

    stateManager.run(async (signal: AbortSignal | undefined) => {
      const response = await calendarService.calendarSets.getMyCalendarSets({
        sort: "displayOrder asc",
        signal,
      });

      if (response.status === HTTP_STATUSES.OK) {
        setMyCalendarSets(response.data);
      }
    }, getCalendarSetsUUID);
  };

  return {
    loading: stateManager.isBusy(),
    myCalendarSets,
    getMyCalendarSets,
  };
};
